<template>
  <div class="kpi-simple-card">
    <div class="kpi-header">
      <span class="kpi-title">{{ title }}</span>
      
      <span v-if="info" class="kpi-info-wrapper">
        <v-icon small class="kpi-info">mdi-information-outline</v-icon>
        <span class="kpi-tooltip" v-if="infoText">{{ infoText }}</span>
      </span>
    </div>
    <div class="kpi-value" v-html="value"></div>
    <div v-if="subtitle" class="kpi-subtitle">{{ subtitle }}</div>
  </div>
</template>

<script>
export default {
  name: "KpiSimpleCard",
  props: {
    title: { type: String, required: true },
    value: { type: String, required: true },
    subtitle: { type: String, default: "" },
    info: { type: Boolean, default: false },
    infoText: { type: String, default: 'etsetsetsetsetse' }
  }
};
</script>

<style scoped>
.kpi-simple-card {
  background: #fff;
  border: 1.5px solid #e0e3ea;
  border-radius: 12px;
  padding: 10px 12px 8px 12px;
  min-width: 180px;
  min-height: 68px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-right: 16px;
}
.kpi-header {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}
.kpi-title {
  color: #545454;
  font-size: 12px;
  font-weight: 600;
  margin-right: 6px;
  line-height: 1.1;
}
.kpi-info-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.kpi-info {
  color: #545454;
  font-size: 13px;
  margin-left: 2px;
}
.kpi-tooltip {
  display: none;
  min-width: 150px;
  position: absolute;
  left: 50%;
  top: 120%;
  transform: translateX(-50%);
  background: #001532;
  color: #fff;
  padding: 12px;
  border-radius: 8px;
  font-size: 15px;
  white-space: pre-line;
  z-index: 1000;

  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
}
.kpi-info-wrapper:hover .kpi-tooltip {
  display: block;
}
.kpi-tooltip::after {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 10px 10px 10px;
  border-style: solid;
  border-color: transparent transparent #0A1B2A transparent;
}
.kpi-value {
  color: #1C1C1C;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0;
  line-height: 1.05;
  word-break: break-word;
}
.kpi-subtitle {
  color: #1976d2;
  font-size: 11px;
  margin-top: 1px;
}
</style> 
